import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {
    reservations: true,
    subscriptions: true,
  },
  production: true,
  staging: false,
  development: false,
  api: 'https://admin.pauly.co',
  facebookAppId: '',
  instrumentationKey: '7146c107-5dce-4073-9b4d-58720905d5ad',
  recaptchaSiteKey: '6LfUh_gtAAAAAC0HKNwuw4pgoPGojK7sS8qMs16v',
  clarityId: 'v96r9ktzdu',
};
